import { ACTIONS } from '../utils/constants';

const paymentFormReducer = (state, action) => {
	const {
		cardNumber,
		cardHolderName,
		expireDate,
		cvc,
		selectedInstallment,
		is3DPayment,
	} = action.payload;

	switch (action.type) {
		case ACTIONS.CHANGE_CARD_NUMBER:
			return { ...state, cardNumber };
		case ACTIONS.CHANGE_CARD_HOLDER_NAME:
			return { ...state, cardHolderName };
		case ACTIONS.CHANGE_EXPIRE_DATE:
			return { ...state, expireDate };
		case ACTIONS.CHANGE_CVC:
			return { ...state, cvc };
		case ACTIONS.IS_3D_PAYMENT:
			return { ...state, is3DPayment };
		case ACTIONS.SELECTED_INSTALLMENT:
			return { ...state, selectedInstallment };
		default:
			return state;
	}
};

const responseDataReducer = (state, action) => {
	const { overview, pageSettings, resultData } = action.payload;

	switch (action.type) {
		case ACTIONS.INITIAL_DATA:
			return { ...state, pageSettings };
		case ACTIONS.RESULT_DATA:
			return { ...state, resultData };
		case ACTIONS.OVERVIEW:
			return { ...state, overview };
		default:
			return state;
	}
};

export const reducer = (state, action) => {
	const {
		currentStep,
		checkoutFormContent,
		isMobile,
		isPaymentWithRegisteredCard,
		stepsLocked
	} = action.payload;

	switch (action.type) {
		case ACTIONS.CHANGE_CARD_NUMBER:
		case ACTIONS.CHANGE_CARD_HOLDER_NAME:
		case ACTIONS.CHANGE_EXPIRE_DATE:
		case ACTIONS.CHANGE_CVC:
		case ACTIONS.IS_3D_PAYMENT:
		case ACTIONS.SELECTED_INSTALLMENT:
			return paymentFormReducer(state, action);
		case ACTIONS.CHECKOUT_FORM_CONTENT:
			return { ...state, checkoutFormContent };
		case ACTIONS.CHANGE_CURRENT_STEP:
			return { ...state, currentStep };
		case ACTIONS.STEPS_LOCKED:
			return { ...state, stepsLocked };
		case ACTIONS.IS_MOBILE:
			return { ...state, isMobile };
		case ACTIONS.IS_PAYMENT_WITH_REGISTERED_CARD:
			return { ...state, isPaymentWithRegisteredCard };
		case ACTIONS.INITIAL_DATA:
		case ACTIONS.RESULT_DATA:
		case ACTIONS.OVERVIEW:
			return responseDataReducer(state, action);
		default:
			return state;
	}
};
